<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="52" height="39" viewBox="0 0 52 39">
		<g fill="none" fill-rule="evenodd" transform="translate(2)">
			<circle cx="31.5" cy="9.5" r="9.5" fill="#2D3E4F"/>
			<path fill="#2D3E4F" d="M49.5 38.5c-1.089-9.664-9.865-17.5-18-17.5s-16.43 7.677-18 17.5"/>
			<path stroke="#2D3E4F" stroke-linecap="round" stroke-width="4" d="M8.5 9.5L8.5 25.5"/>
			<path stroke="#2D3E4F" stroke-linecap="round" stroke-width="4" d="M8.5 9.5L8.5 25.5" transform="rotate(90 8.5 17.5)"/>
		</g>
	</svg>
</template>
<script>
export default { name: 'add-user-icon' }
</script>
